export default __webpack_public_path__ + "static/media/logoutGold.568f61a0.svg";